export interface InvestmentCost {
  id: string
  spreadsheetName: string
  minInvestment: number
  maxInvestment: number
}

export const investmentCostList: InvestmentCost[] = [
  {
    id: 'heating-pump-ground',
    spreadsheetName: 'Bergvärme',
    minInvestment: 180_000,
    maxInvestment: 350_000,
  },
  // We do not have any "Värmepump Mark" in the api response
  {
    id: 'heating-pump-water',
    spreadsheetName: 'Värmepump luft/vatten',
    minInvestment: 150_000,
    maxInvestment: 150_000,
  },
  {
    id: 'heating-pump-exhaust-air',
    spreadsheetName: 'Värmepump Frånluft',
    minInvestment: 60_000,
    maxInvestment: 110_000,
  },
  {
    id: 'solar_panel_power_4',
    spreadsheetName: 'Solceller 4 kW',
    minInvestment: 100_000,
    maxInvestment: 120_000,
  },
  {
    id: 'solar_panel_power_10',
    spreadsheetName: 'Solceller 10 kW',
    minInvestment: 150_000,
    maxInvestment: 200_000,
  },
  {
    id: 'district',
    spreadsheetName: 'Fjärrvärmecentral',
    minInvestment: 65_000,
    maxInvestment: 110_000,
  },
  // TODO: When we recieve investment costs these can be added here
  // {
  //   id: 'insulation_walls_20', 
  //   spreadsheetName: '',
  //   minInvestment: 00_000,
  //   maxInvestment: 00_000,
  // },
  // {
  //   id: 'insulation_roof_40',
  //   spreadsheetName: '',
  //   minInvestment: 00_000,
  //   maxInvestment: 00_000,
  // }
]

export function getInvestmentCostCopyById(id: string) {
  const investmentCostObj = investmentCostList.find((investment) => investment.id === id)
  if (!investmentCostObj) return undefined
  if (investmentCostObj.minInvestment === investmentCostObj.maxInvestment)
    return `ca ${investmentCostObj.minInvestment.toLocaleString('sv-SE')} kr`
  return `ca ${investmentCostObj.minInvestment.toLocaleString('sv-SE')} - ${investmentCostObj.maxInvestment.toLocaleString('sv-SE')} kr`
}
